/**
 * @generated SignedSource<<20548164f1c82e7d7711305d992f1cd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectNote_note$data = {
  readonly created_at: string;
  readonly created_by: string | null | undefined;
  readonly creator_email: string | null | undefined;
  readonly id: number;
  readonly note: string;
  readonly project: {
    readonly id: number;
    readonly isTemplate: boolean;
  };
  readonly updated_at: string;
  readonly user_id: number | null | undefined;
  readonly " $fragmentType": "ProjectNote_note";
};
export type ProjectNote_note$key = {
  readonly " $data"?: ProjectNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectNote_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectNote_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_by",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creator_email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "isTemplate",
          "args": null,
          "kind": "ScalarField",
          "name": "is_template",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "notes",
  "abstractKey": null
};
})();

(node as any).hash = "6a3bacf15310c93d64387f08a6ffcc12";

export default node;
